import React, { useEffect, useRef, useState } from 'react'
import { Button } from "react-bootstrap";
import { CalendarToday } from "@mui/icons-material";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import "../../assets/style.css";
import { styled } from '@mui/material/styles'
import { Typography } from "@mui/material";
import { makeRequest } from '../../core/services/v1/request'
import Config from "../../core/config";
import { useNavigate } from 'react-router-dom';

const ViewAllButton = styled(Button)({
  marginTop: '24px',
  textTransform: 'none',
  borderRadius: '12px',
  padding: '12px 48px',
  fontSize: '1rem',
  fontWeight: 500,
  backgroundColor: 'transparent',
  color: '#fff',
  border: '1px solid #23262F',
  '&:hover': {
    backgroundColor: '#21242C',
    borderColor: '#21AB9D',
    '& .MuiSvgIcon-root': {
      transform: 'translateX(5px)',
    },
  },
  '& .MuiSvgIcon-root': {
    transition: 'transform 0.3s ease',
  },
})

const categoryClass = {
  Market: "badge-market",
  Guide: "badge-guide",
  Regulation: "badge-regulation",
};

const BlogCard = ({ post }) => {
  const titleRef = useRef(null);
  const [titleLines, setTitleLines] = useState(2);
  useEffect(() => {
    if (titleRef.current) {
      const lineHeight = parseFloat(
        window.getComputedStyle(titleRef.current).lineHeight
      );
      const height = titleRef.current.offsetHeight;
      const lines = Math.round(height / lineHeight);

      setTitleLines(lines);
    }
  }, [post?.title]);
  return (
    <a href={post?.link} style={{ textDecoration: "none", color: "inherit" }}>
      <div className="blogHome-card">
        <div className="blogHome-image">
          <img src={post?.image} alt={post?.title} />
          {/* <span className="blogHome-badge badge-market">
            {post?.categoryId?.name}
          </span> */}
        </div>
        <div className={`blogHome-content title-lines-${titleLines}`}>
          <h5 ref={titleRef}>{post?.title}</h5>

          <p className="blogHome-desc">
            {post?.description?.replace(/<[^>]+>/g, "")}
          </p>

          <div style={{ height: "15px" }}>
            <div className="blogHome-meta">
              <span>
                <CalendarToday fontSize="small" />{" "}
                {post?.dateTime?.slice(0, 10)}
              </span>
            </div>
            <div className="blogHome-meta-category">
              <span className="blogHome-badge badge-market">
                {post?.categoryId?.name === post?.categoryId?.name?.toUpperCase()
                  ? post?.categoryId?.name
                  : post?.categoryId?.name
                    ?.toLowerCase()
                    ?.replace(/\b\w/g, (c) => c.toUpperCase())}
              </span>
            </div>
          </div>
        </div>
      </div>
    </a>
  );
};

const BlogSection = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate()
  const fetchBlogs = async () => {
    try {
      setLoading(true);
      setBlogs([]);

      const res = await makeRequest({
        url: `${Config.V2_API_URL}cms/getBlogs?page=1&limit=9&categoryId=all`,
        method: "GET",
      });

      if (res.status) {
        setBlogs(res?.getBlogsDetails);
      }

      setLoading(false);
      // window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    } catch (err) {
      console.log(err);
      setLoading(false);
      setBlogs([]);
    }
  };
  useEffect(() => {
    fetchBlogs();
  }, []);
  return (
    <section className="blogHome-section">
      <div className="container text-center mb-5">
        <Typography
          variant='h3'
          component='h2'
          sx={{
            fontWeight: 'bold',
            mb: 2,
            fontSize: { xs: '2rem', md: '3rem' },
          }}
        >
          Insights & Market{' '}
          <span
            style={{
              display: 'inline-block',
              backgroundImage: 'linear-gradient(to right, #21AB9D, #34d399)',
              WebkitBackgroundClip: 'text',
              backgroundClip: 'text',
              color: 'transparent',
            }}
          >
            Intelligence
          </span>
        </Typography>
        <Typography
          variant='body1'
          sx={{ color: '#9AA6B2', fontSize: '1.1rem' }}
        >
          Stay ahead with expert analysis, crypto guides, and market trends.
        </Typography>
      </div>

      {/* Marquee */}
      <div className="marquee-wrapper">
        <div className="marquee-track">
          {(blogs && !loading) ? blogs.map((post, i) => (
            <BlogCard key={i} post={post} />
          )) : null}
        </div>
      </div>

      <div className='container'>
        <div className='text-center'>
          <ViewAllButton variant='outlined' endIcon={<ArrowForwardIcon />} onClick={() => navigate('/blog')}>
            View All Articles
          </ViewAllButton>
        </div>
      </div>
    </section>
  );
};

export default BlogSection;
